import React, { useState, useCallback, useEffect } from "react";
import {Modal,Paper,Typography,CircularProgress,useTheme,Box} from "@material-ui/core";
import { Close} from "@material-ui/icons";
import { pathOr} from "ramda";
import { MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import { Scrollbars } from 'react-custom-scrollbars';
import { toast } from "react-toastify";

import {getAuditViewData} from "../../store/actions/module.actions";

import useStyles, { getMuiTheme } from "./styles";
import {NoRecord } from "../../components";

const AuditView = ({module, record, modalVisible,toggleModalVisibility}) => {
  
  const [auditViewData, setAuditViewData] = useState({});
  
  const [listViewMeta, setListViewMeta] = useState({
    page: 0,
  });
  const [loading, setLoading] = useState(false);
  //const [fieldErrors, setErrors] = useState(errors);
  
  const classes = useStyles();
  const theme = useTheme();

  let popupTitle = pathOr(
      "Change Log",
      ["data", "title"],
      auditViewData,
    );
  const fetchAuditViewData = useCallback(async () => {
    if (modalVisible) {
      try {
        setLoading(true);
        const res = await getAuditViewData(module, record);
        if (res.ok) {
          setAuditViewData(res.data);
        }
        setLoading(false);
      } catch (ex) {
        setLoading(false);
        toast("Something went wrong!");
      }
    }
  }, [module,record, modalVisible]);

  useEffect(() => {
    fetchAuditViewData();
  }, [fetchAuditViewData]);


  const renderLoader = () => (
    <div className={classes.progressWrapper}>
      <CircularProgress />
    </div>
  );

  const renderListView = () => {
    
    let data = pathOr(
      [],
      ["data", "templateMeta", "listview", "data"],
      auditViewData,
    );

    let columns = pathOr(
      [],
      ["data", "templateMeta", "listview", "datalabels"],
      auditViewData,
    );
    
    let auditedFields = pathOr(
      [],
      ["data", "templateMeta", "listview", "auditedFields"],
      auditViewData,
    );

    const changePageOrSort = async (page, sort) => {
      try {
        //setListViewLoading(true);
        setListViewMeta({ page });
        const res = await getAuditViewData(
          module,
          record,
          20,
          page + 1,
          sort,
        );
        setAuditViewData(res.data);

        //setListViewLoading(false);
      } catch (e) {
        //setListViewLoading(false);
      }
    };

    return (
      <>
      
      <MuiThemeProvider theme={getMuiTheme(theme)}>
        <Typography variant="subtitle2" style={{fontWeight:400,marginBottom:10}}>
          {auditedFields.title}
          {auditedFields.fields}
        </Typography>
        <MUIDataTable
          // title={
          //   <Typography variant="h6">
          //     {module}
          //     {listViewLoading && <CircularProgress size={24} />}
          //   </Typography>
          // }
          data={data.map((it) => it.attributes)}
          columns= {data.length > 0 ? columns : []}
          options={{
            filter: false,
            download: false,
            print: false,
            viewColumns: false,
            selectableRows: false,
            page: listViewMeta["page"],
            count: pathOr(0, ["meta", "total-records"], auditViewData),
            pagination: pathOr([], ["meta", "total-records"], auditViewData) > 0 ? true : false,
            search: false,
            rowsPerPage: 20,
            fixedHeader: true,
            serverSide: true,
            //tableBodyHeight: "500px",
            rowsPerPageOptions: [20],
            textLabels: {
              body: { 
                noMatch: loading ? ''
                  : 
                 <NoRecord view = 'subpanel' />
              },
            },
            onTableChange: (action, tableState) => {
              switch (action) {
                case "changePage":
                  if (tableState.sortOrder.hasOwnProperty("name")) {
                    let directionToSort =
                      tableState.sortOrder.direction === "desc"
                        ? `-${tableState.sortOrder.name}`
                        : tableState.sortOrder.name;
                    changePageOrSort(tableState.page, directionToSort);
                    // setListViewMeta({
                    //   ...listViewMeta,
                    //   page: tableState.page + 1,
                    // });
                    break;
                  }
                  changePageOrSort(tableState.page);
                  break;
                case "sort":
                  if (tableState.sortOrder.direction === "desc") {
                    changePageOrSort(
                      tableState.page,
                      `-${tableState.sortOrder.name}`,
                    );
                    break;
                  }
                  changePageOrSort(
                    tableState.page,
                    tableState.sortOrder.name,
                  );

                  break;
                default:
                  console.log("action not handled.");
              }
            },
          }}
        />
      </MuiThemeProvider>
      </>
    );
  };

  const renderViews = () => {
    return (
      <div className={classes.sectionsWrappers}>
        <Box>
          {renderListView()}
        </Box>
      </div>
    );
  };

  const renderBody = () => {
    return (
      <Paper square className={classes.paper}>
        <Scrollbars autoHide={true}>
          <div className={classes.titleHeadWrapper}>
            <Typography variant="h6" style={{ fontWeight: "500", color: theme.palette.text.primary }}>
              {popupTitle}
            </Typography>
            <Close
              onClick={() => toggleModalVisibility(!modalVisible)}
              className={classes.closeIcon}
            />
          </div>
          
          {loading ? renderLoader() : renderViews()}
          
        </Scrollbars>
      </Paper>
    );
  };

  return (
    <>
      
      <Modal
        open={modalVisible}
        onClose={() => toggleModalVisibility(!modalVisible)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {renderBody()}
      </Modal>
    </>
  );
};

export default AuditView;
